import { createReducer } from "@reduxjs/toolkit";
import { getListActionSuccess, loading } from "./productRecallAction";

export interface IProductState {
  productRecalls: any[];
  filters: any[];
  dataCount: number;
  isLoading: boolean;
  productRecallName: any;
  // filters: Array<IFilter>;
}

const initialState: IProductState = {
  productRecalls: [],
  filters: [],
  dataCount: 0,
  isLoading: false,
  productRecallName: "",
};
export const productRecallReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loading, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getListActionSuccess, (state, action) => {
      state = {
        ...state,
        productRecalls: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    });
});
